import { PropsWithChildren } from "react";

type Props = PropsWithChildren<object>;

export default function Header({ children }: Props) {
  return <header>{children}</header>;
}
